<script>
    import {push, pop} from 'svelte-spa-router';
    import Header from './Header.svelte';
    export let params = {}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

	let dash_token_link = dash_token;
	if (dash_token_link != '1') {
		dash_token_link = '2'
	}

    let mebot_id = getCookie('m_id');
    let h_id = params.h_id;


    let stat_mebot_id = params.m_id

    let mebot_trips = [];
	let mebot_trips_tmp = [];
	let mebot_attr = [];

	let habitat_name = '';
	let visit_msg = '';
	let habitat;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

    async function getHabitatPlaces() {

		const res = await fetch(
			"https://api.forever.today/?method=get_habitat_places",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
                    file_id: h_id
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.trips;

		mebot_trips_tmp = [];
		let info_str = '';
		let land = null;

		for (const runner of runners) {

			land = null;
			if (runner.info != null) {
				info_str = runner.info

				if (runner.land_img != null) {
					land = runner.land_img
				}
			} else {
				info_str = runner.eff + '%'
			}
			mebot_trips_tmp.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				land_img: land,
				land_file_id: runner.land_file_id,
				sparkles: runner.sparkles,
				eff: runner.eff,
				info: info_str,
				time_ago: runner.time_ago,
				emoji: runner.emoji,
				ts: runner.ts,
				is_claimed: runner.is_claimed,
				place_id: runner.place_id,
				claimed_m_id: runner.claimed_m_id,
				rating: runner.rating,
				title: runner.title,
				claimed_by: runner.claimed_by,
				is_origin: runner.io,
			});
		}

		habitat = json.data.hab;
		habitat_name = json.data.hab.name;
		visit_msg = json.data.hab.visit_msg;

		//mebot_trips = mebot_trips_tmp.slice(0, 14);
		mebot_trips = mebot_trips_tmp;

	}

    getHabitatPlaces();

	let y;

	async function claimPlace(place_id) {

		//if (habitat.visited == 1) {

		const res = await fetch(
			"https://api.forever.today/?method=claim_habitat_place",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
                    file_id: h_id,
					place_id
				}),
			}
		);

		getHabitatPlaces();

		//}
	}

</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>

<!--<center>
    <div style="width: 300px; overflow: hidden">
        <iframe title="iframe" src="/ifeed.html" width="307" height="800"
            scrolling="yes" style="width: 307px; height: 800px; border:none;"
            allowtransparency="true">
            Mebots content            
        </iframe>
    </div>
</center>-->

<center>
<div class="main1">
    <table width=340px valign=top border=0 cellspacing=8>

	<tr height=45px>
		<td align=center valign=middle width=50px style="padding: 4px;">
			{#if habitat_name != '' }
				<div class="message question no_tap_zoom" on:click={ () => pop() }>
					<img src="{ habitat.land_img_sm }" class="no_tap_zoom land_sm" style="user-select: none;" width=50px height=50px alt="Land42">
				</div>
			{/if}
		</td>

		<td width=160px colspan=2 valign=middle style="padding: 4px;">
			<span style="font-size: 14px; margin-bottom: 12px;" on:click={ () => pop() }>
				{#if habitat_name != '' }
				<span class="text-electric">🟧 { habitat_name }</span> <span class="itals-mid text-glow-blueish" style="white-space: nowrap;"><span class="text-hl">Portals</span> </span>
				{/if}
			</span>
		</td>

		<td width=90px colspan=1 valign=middle align=center>
			{#if habitat_name != '' && visit_msg != '' }
			<span class="text-hl" style="font-size: 10px;">
				{@html visit_msg }
			</span>
			{/if}
<!--			<span class="text-glow1 mebot-byline" style="font-size: 18px;" on:click={ () => pop() }>
				&nbsp;&nbsp; ✖️ &nbsp; 
			</span>
-->
		</td>
	</tr>
    {#each mebot_trips as trip, i}
    <tr height=65px>
    <td align=center valign=middle width=50px style="padding: 4px;">

		{#if trip.is_origin == 1 }
		<div class="text-glow-blueish text-hl" style="font-size: 10px; margin: 4px;"> <span class="text-electric" style="font-size: 10px; white-space: nowrap; ">Origin Portal</span> <br> </div>
		{:else}
		<div class="text-glow-blueish"> &nbsp; </div>
		{/if}

        <div class:text-electric-wormhole1={ trip.is_origin == 1 } class="emojis" style="white-space: nowrap;">&nbsp; <span class="text-glow-blueish">{ trip.emoji }</span> &nbsp;</div>
		{#if trip.rating != '' }
		<span class="text-glow-blueish text-hl" class:text-electric={ trip.is_origin == 1 } style="font-size: 10px;"> { trip.rating } ⭐ </span>
		{:else}
		<div class="text-glow-blueish"> &nbsp; </div>
		{/if}
    </td>
    <td width=160px colspan=2 valign=middle>

		<span class="vitals-mid text-glow-blueish"><span class="text-hl">{@html trip.info }</span></span> </td>
<!--    <td width=50px align=right valign=top on:click={ () => { if (trip.ts > 0) { push('/i/' + dash_token_link + '/' + trip.ts) } } }> <span class="vitals-small text-glow-gray" class:text-hl={ (trip.ts > 0) } >{trip.time_ago}</span> &nbsp;</td>-->
	<td width=90px valign=center style="white-space: nowrap; padding-top: 8px;" align=middle>


		{#if habitat.visited == 1 }
		{#if trip.is_claimed == 0 }
		
			&nbsp;<button class:text-electric-wormhole2={ trip.is_origin == 1 } class="text-electric submenu_active tooltip1" on:click={ () => claimPlace(trip.place_id) }> {@html trip.title } </button>&nbsp;
		{:else}
			{#if trip.claimed_m_id == mebot_id }
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish"> &nbsp; </div>
			{/if}
			<button class:text-electric-wormhole1={ trip.is_origin == 1 } class="text-electric-white submenu_inactive tooltip1"> {@html trip.title } </button>
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish text-hl" style="font-size: 10px;"> {@html trip.claimed_by } </div>
			{/if}
			{:else}
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish"> &nbsp; </div>
			{/if}
			<button class:text-electric-wormhole2={ trip.is_origin == 1 } class="text-electric-purple is_dis taken" on:click={ () => claimPlace(trip.place_id) }> {@html trip.title } </button>
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish text-hl" style="font-size: 10px;"> {@html trip.claimed_by } </div>
			{/if}
			{/if}
		{/if}
		{:else}
		{#if trip.is_claimed == 0 }
			&nbsp;<button class="is_dis"  on:click={ () => claimPlace(trip.place_id) }> {@html trip.title } </button>&nbsp;
		{:else}

			{#if trip.claimed_m_id == mebot_id }
			<!--<button class="submenu_inactive tooltip1 is_dis">&nbsp;&nbsp;&nbsp; 🟧 &nbsp;&nbsp;&nbsp;</button>-->

			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish"> &nbsp; </div>
			{/if}
			<button class="text-electric-white submenu_inactive tooltip1"> {@html trip.title } </button>
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish text-hl" style="font-size: 10px;"> {@html trip.claimed_by } </div>
			{/if}

			{:else}
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish"> &nbsp; </div>
			{/if}
			<button class="text-electric-purple is_dis taken" on:click={ () => claimPlace(trip.place_id) }> {@html trip.title } </button>
			{#if trip.claimed_by != '' }
			<div class="text-glow-blueish text-hl" style="font-size: 10px;"> {@html trip.claimed_by } </div>
			{/if}
			{/if}

		{/if}
		{/if}
	</td>
    </tr>
    {/each}
    </table>
    <br><br><br><br><br><br>
    <br><br><br><br><br><br>
</div>
</center>

<style>

.main1 {
    border-radius: 20px;
    background-color: rgba(0, 24, 39, 0.6);
    background-color: linear-gradient(rgba(0, 24, 39, 0.6), rgba(0,0,0,0.6));
    height: 700px;
    width: 370px;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    padding: 0px;
    overscroll-behavior: auto;
    border: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.main1::-webkit-scrollbar {
  display: none;
}

.submenu_active {
    background-color: #202020;
    box-shadow: 0 5px 10px rgb(181, 188, 192);
	white-space: nowrap;
}

.submenu_inactive {
    background-color: #ff9500da;
	border: 1px solid rgba(255, 255, 255, 0.35);
	box-shadow: 0 5px 10px rgb(168, 151, 133);
	white-space: nowrap;
	color: white;
}

.is_dis {
	background-color: #001f26;
	color: rgb(0, 106, 128);
    box-shadow: 0 5px 10px rgb(0, 41, 49);
	white-space: nowrap;
	border-radius: 6px;
	border: 1px solid rgb(0, 65, 81);
	padding: 3px;
	font-size: 14px;
}

.taken {
    background-color: #1e1b20;
	color: rgb(119, 71, 131);
	border: 1px solid rgb(148, 83, 164);
    box-shadow: 0 5px 10px rgb(117, 1, 143);
}

.tooltip1 {
	margin-top: 0px;
	font-size: 14px;
	border-radius: 6px;
	border: 1px solid rgba(255, 255, 255, 0.35);
	color: white;
	padding: 3px;
}

.main {
		background-color: rgba(0, 0, 0, 0.465);
		overflow-x: auto;
		overflow-y: auto;
		background-image: url("/img/nyc_bg_sm.jpeg");
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		touch-action: manipulation;
		overflow: auto;
		-webkit-appearance: none;
		overscroll-behavior: auto;
    height: 4000px;  
    margin-top: 50px;
}

.vitals-small {
	font-size: 12px;
}

.vitals-mid {
	font-size: 14px;
}

.text-glow-blueish {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: hsl(185, 40%, 70%);
}

.text-glow-gray {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: rgba(255, 255, 255, 0.465);
}

.text-hl {
	color: rgba(255, 255, 255, 0.845);
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
}

.emojis {
	border-radius: 6px;
    background-color: #008e931d;
	padding: 8px;
	font-size: 12px;
}

.land_sm {
	border-radius: 10px;
}

.text-electric {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
}
.text-electric-white {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(0, 0%, 98%, 0.98);
		font-family: arial;
		color: hsl(180, 33%, 98%);
}
.text-electric-purple {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(237, 192, 255, 0.9),
			0 0 14px hsla(279, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(270, 97%, 75%);
}
.text-electric-wormhole1 {
    background: linear-gradient(129deg,#ff8300, #725cd8,  #090033, #ff0000);
    background-size: 800% 800%;

    -webkit-animation: AnimationName1 5.8s ease infinite;
    -moz-animation: AnimationName1 5.8s ease infinite;
    -o-animation: AnimationName1 5.8s ease infinite;
    animation: AnimationName1 5.8s ease infinite;
}
.text-electric-wormhole2 {
    background: linear-gradient(129deg,#af5d04, #725cd8,  #090033, #5e0606);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 5.8s ease infinite;
    -moz-animation: AnimationName 5.8s ease infinite;
    -o-animation: AnimationName 5.8s ease infinite;
    animation: AnimationName 5.8s ease infinite;
}
@-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
</style>